import React, { useState } from "react";
import styles from "../styles/header.module.scss";
import { translations } from "../translation";
import logo from "../assets/images/EpileX-IA-logo.png";

const Header = ({ getLanguage }: any) => {
	type Language = "en" | "es";
	const [lang, setLang] = useState<Language>("en");

	const toggleLanguage = () => {
		setLang((prev) => {
			const newLang = prev === "en" ? "es" : "en";
			getLanguage(newLang);
			return newLang;
		});
	};
	const t = translations[lang];
	return (
		<header>
			<nav className={`navbar navbar-expand-lg px-4 ${styles["navbar-custom"]}`}>
				<div className="navbar-brand text-white">
					<img className=" rounded-circle" src={logo} alt="Logo" height="60" />
				</div>
				<button className="btn btn-outline-light" onClick={toggleLanguage}>
					{lang === "en" ? "EN" : "ES"}
				</button>
				<div className="ms-auto">
					<div className="dropdown">
						<button
							className="btn dropdown-toggle text-white"
							type="button"
							id="dropdownMenuButton"
							data-bs-toggle="dropdown"
							aria-expanded="false">
							{t.menu}
						</button>
						<ul
							className={`dropdown-menu dropdown-menu-end bg-dark ${styles["dropdown-menu-navbar"]}`}
							aria-labelledby="dropdownMenuButton">
							<li>
								<a className="dropdown-item text-white" href="#platform">
									{t.menuLink1}
								</a>
							</li>
							<li>
								<a className="dropdown-item text-white" href="#clinical-challenge">
									{t.menuLink2}
								</a>
							</li>
							<li>
								<a className="dropdown-item text-white" href="#solution">
									{t.menuLink3}
								</a>
							</li>
							<li>
								<a className="dropdown-item text-white" href="#inside">
									{t.menuLink4}
								</a>
							</li>

							<li>
								<a className="dropdown-item text-white" href="#mobile">
									{t.menuLink8}
								</a>
							</li>
							<li>
								<a className="dropdown-item text-white" href="#collaborators">
									{t.menuLink9}
								</a>
							</li>
							<li>
								<a className="dropdown-item text-white" href="#ethics">
									{t.menuLink10}
								</a>
							</li>
							<li>
								<a className="dropdown-item text-white" href="#investors">
									{t.menuLink11}
								</a>
							</li>
							<li>
								<a className="dropdown-item text-white" href="#contact-us">
									{t.menuLink12}
								</a>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</header>
	);
};

export default Header;
